import {
  MEASUREMENT_SYSTEMS,
  UNIT_SYMBOLS,
} from '@src/constants/measureUnits.js';
import formatNumber from '@src/utils/formatNumber.js';
import {convertArea} from '@turf/helpers';
import {number, string} from 'prop-types';
import {useSelector} from 'react-redux';

const AreaLabel = ({squareMeters, labelUnit}) => {
  const selectedUnit = useSelector(state =>
    state.settings.measurementSystem === MEASUREMENT_SYSTEMS.metric
      ? state.settings.areaUnitsMetric
      : state.settings.areaUnitsUSC,
  );
  const unit = labelUnit || selectedUnit;

  const turfUnit = unit.replace('square-', '');

  const area = convertArea(squareMeters, 'meters', turfUnit);

  return `${formatNumber(area, {minimumFractionDigits: 4, maximumFractionDigits: 4})} ${UNIT_SYMBOLS[unit]}`;
};

AreaLabel.propTypes = {
  squareMeters: number,
  unit: string,
};

export default AreaLabel;
